import axios from 'axios';

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor to add token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('astraos_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor to handle responses
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - token expired or invalid
    if (error.response?.status === 401) {
      console.error('Auth token expired or invalid');
      localStorage.removeItem('astraos_token');
      if (axiosInstance.defaults.headers && axiosInstance.defaults.headers.common) {
        delete axiosInstance.defaults.headers.common['Authorization'];
      }
      window.location.href = '/';
    }
    
    // Handle 403 Forbidden - no permission
    if (error.response?.status === 403) {
      console.error('Permission denied:', error.response?.data?.error || 'No tienes permisos para esta acción');
    }

    return Promise.reject(error);
  }
);

// Helper functions wrapper that return response.data directly
const api = {
  get: async (url, config = {}) => {
    try {
      const response = await axiosInstance.get(url, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error de conexión', code: 'NETWORK_ERROR' };
    }
  },

  post: async (url, data, config = {}) => {
    try {
      const response = await axiosInstance.post(url, data, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error de conexión', code: 'NETWORK_ERROR' };
    }
  },

  put: async (url, data, config = {}) => {
    try {
      const response = await axiosInstance.put(url, data, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error de conexión', code: 'NETWORK_ERROR' };
    }
  },

  patch: async (url, data, config = {}) => {
    try {
      const response = await axiosInstance.patch(url, data, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error de conexión', code: 'NETWORK_ERROR' };
    }
  },

  del: async (url, config = {}) => {
    try {
      const response = await axiosInstance.delete(url, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Error de conexión', code: 'NETWORK_ERROR' };
    }
  },
  
  // Expose axios instance defaults for direct header manipulation
  get defaults() {
    return axiosInstance.defaults;
  }
};

export default api;
